import moment from "moment";
import React from "react";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import CarePlanButton from "./CarePlanButton";
import EncounterButton from "./EncounterButton";
import IncidentReportButton from "./IncidentReportButton";

const ClientButtonBar = ({ contactId, contactOwner, programs, size }) => {
  const navigate = useNavigate();

  const mobileCrisis = programs
    ? programs.filter(
        (p) => p === "SAFY of Colorado - Aurora - Mobile Crisis Response"
      ).length === programs.length
    : false;

  return (
    <>
      <EncounterButton
        className="me-1 mb-1 bg-safy3-1"
        size={size}
        contactID={contactId}
      />
      {!mobileCrisis && (
        <CarePlanButton
          className="me-1 mb-1 bg-safy3-1"
          size={size}
          contactID={contactId}
        />
      )}
      {!contactOwner.includes("South Carolina") &&
      !contactOwner.includes("Indiana") &&
      moment().isBefore(moment("2024-08-21")) ? (
        <IncidentReportButton
          className="me-1 mb-1 bg-safy3-1"
          size={size}
          contactID={contactId}
        />
      ) : null}
      <Button
        className="me-1 mb-1 bg-safy3-1"
        size={size}
        onClick={() => {
          navigate(`/client/${contactId}`, { state: { tab: "forms" } });
        }}
      >
        {moment().isBefore(moment("2024-08-21"))
          ? "Client Forms"
          : "Client Forms & IR"}
      </Button>
      {!mobileCrisis && (
        <Button
          className="me-1 mb-1 bg-safy3-1"
          size={size}
          onClick={() => {
            navigate(`/client/${contactId}`, { state: { tab: "cpass" } });
          }}
        >
          Assessments
        </Button>
      )}
    </>
  );
};

export default ClientButtonBar;
